import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withNamespaces } from "react-i18next";

import { Accordion } from "react-bootstrap";
import SidebarContainer from "~/containers/SidebarContainer";
import ApplicationMenuItem from "~/containers/Menus/components/ApplicationMenuItem";
import Spinner from "~/components/Spinner";

import { findMenuByApplicationName } from "~/store/ducks/applicationMenu/actionTypes";

const ApplicationMenu = ({ applicationName, showMenu = true }) => {

  const dispatch = useDispatch();

  const {
    isLoadingMenu,
    successDelete,
    successEdit
  } = useSelector(state => state.applicationMenuReducer);

  useEffect(() => {
    if (applicationName) {
      dispatch(findMenuByApplicationName(applicationName));
    }
  }, []);

  useEffect(() => {
    if ((successEdit || successDelete) && applicationName) {
      dispatch(findMenuByApplicationName(applicationName));
    }
  }, [successDelete, successEdit]);

  const [mainActiveKey, setMainActiveKey] = useState("")
  //console.log("mainActiveKey", mainActiveKey)
  return (
    <SidebarContainer>
      <Accordion className="menu" id={`app-${applicationName}`} activeKey={mainActiveKey}>
        {
          !isLoadingMenu &&
          <ApplicationMenuItem
            applicationName={applicationName}
            showMenu={showMenu}
            setMainActiveKey={setMainActiveKey}
            mainActiveKey={mainActiveKey}
          />
        }
        <Spinner spinning={isLoadingMenu} />
      </Accordion>
    </SidebarContainer>
  )
}
export default withNamespaces()(ApplicationMenu)
